import Swal from "sweetalert2";

export const startHearingAlert = () => Swal
    .fire({
        title: 'Iniciar audiência.',
        text: 'Ao iniciar a audiência, o link de acesso ao meet será liberado publicamente. Ao entrar no meet não esqueça de iniciar a gravação!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
    });


export const stopHearingAlert = () => Swal
    .fire({
        title: 'Finalizar audiência.',
        text: 'Ao finalizar a audiência, a conferência do meet será finalizada.',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Ok',
    });


export const cancelHearingAlert = () => Swal
    .fire({
        title: 'Cancelar audiência.',
        text: 'Após cancelada, não é possível desfazer essa ação, deseja realmente cancelar?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
    });



export const enterAsConferenceAttendee = () => Swal
    .fire({
        title: 'Atendimento agendado.',
        text: 'Ao acessar a sala você se tornará o responsável pelo atendimento, deseja continuar?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
    });


export const enterVideoAttendance = () => Swal
    .fire({
        title: 'Atendimento em video iniciado.',
        text: 'O atendente iniciou o atendimento em video, deseja entrar?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
    });

